import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { IconUiSuccess } from '../';
import { forbiddenPropType, sharedInputButtonTypes } from '../utils/proptypes';
import withListItemWrapper from '../with-list-item-wrapper';
import { InputButton } from './input-button';
function Checkbox(_ref) {
  var disabled = _ref.disabled,
    checked = _ref.checked,
    multiple = _ref.multiple,
    hasError = _ref.hasError,
    props = _objectWithoutProperties(_ref, ["disabled", "checked", "multiple", "hasError"]);
  return jsx(InputButton, _extends({
    mainIcon: jsx("span", {
      sx: _objectSpread(_objectSpread(_objectSpread({}, styles.icon), checked && styles.icon.checked), disabled && styles.icon.disabled)
    }, checked && (multiple ? jsx("span", {
      sx: _objectSpread(_objectSpread(_objectSpread({}, styles.innerIcon), styles.minusIcon), disabled && styles.minusIcon.disabled)
    }) : jsx(IconUiSuccess, {
      sx: _objectSpread(_objectSpread({}, styles.innerIcon), disabled && styles.innerIcon.disabled)
    }))),
    checked: checked,
    type: InputButton.TYPES.checkbox,
    disabled: disabled
  }, props));
}
var styles = {
  icon: {
    display: 'inline-block',
    position: 'relative',
    width: '16px',
    height: '16px',
    borderRadius: 1,
    border: 1,
    borderColor: 'grey.7',
    boxShadow: 'input',
    backgroundColor: 'grey.0',
    checked: {
      backgroundColor: 'blue.darkest'
    },
    disabled: {
      backgroundColor: 'grey.6'
    }
  },
  innerIcon: {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    color: 'grey.0',
    disabled: {
      color: 'grey.7'
    }
  },
  minusIcon: {
    width: '8px',
    height: '1px',
    backgroundColor: 'grey.0',
    disabled: {
      backgroundColor: 'grey.7'
    }
  }
};
Checkbox.defaultProps = {
  multiple: false
};
var mapProps = function mapProps(_ref2) {
  var checked = _ref2.checked;
  return {
    selected: checked
  };
};
var ListItemCheckbox = withListItemWrapper(mapProps)(Checkbox);
export { Checkbox, ListItemCheckbox };